import React from 'react';

export default function NoLocationStep(props) {
    return (
        <div className={"container mx-auto px-4 lg:px-8"}>
            <div className={"grid grid-cols-1 lg:grid-cols-12 gap-x-8"}>
                <div className={"lg:col-span-8 lg:col-start-3"}>
                    <h2>
                        Sorry, we don’t currently service your area!
                    </h2>
                    <p>
                        We appreciate your interest in Bin There Dump That. While we don’t have a location in your area
                        yet, we’re always expanding! In the meantime, feel free to contact us with any questions—we’d
                        still love to help point you in the right direction.
                    </p>
                    <p>
                        <a href="/contact" className="btn">Get In Touch</a>
                    </p>
                    <p>
                        We apologize for not being in your area… yet 👀. If you’re interested in bringing our friendly
                        and simple dumpster rental services to your area, why not become a Franchise Operator? Learn
                        more below!
                    </p>
                    <p>
                        <a href="https://www.bintheredumpthatfranchise.com/" className="btn">Your Future Awaits</a>
                    </p>
                </div>
            </div>
        </div>
    )
}